import type { VideoDetails } from '..'

export default function getVimeoDetails(url: string): VideoDetails {
  // Perhaps it already is an unlisted player URL
  const unlistedPlayerRegex =
    /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/video\/(\d+)\?h=([a-z0-9]+)/g
  const unlistedPlayerMatches = Array.from(url.matchAll(unlistedPlayerRegex))[0]

  if (
    unlistedPlayerMatches &&
    unlistedPlayerMatches[1] &&
    unlistedPlayerMatches[2]
  ) {
    return {
      id: unlistedPlayerMatches[1],
      hash: unlistedPlayerMatches[2],
    }
  }

  const listedRegex =
    // For some reason it thinks that the last \/ is unnecessary, but the entire regex becomes illegal if that's removed.
    // eslint-disable-next-line no-useless-escape
    /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)[^\s\/]*$/g
  const listedMatches = Array.from(url.matchAll(listedRegex))[0]

  // Not in format vimeo.com/video/{id}
  if (listedMatches && listedMatches[1]) {
    return {
      id: listedMatches[1],
    }
  }

  // So perhaps an unlisted video
  const unlistedRegex =
    /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)\/([a-z0-9]+)/g
  const unlistedMatches = Array.from(url.matchAll(unlistedRegex))[0]

  if (unlistedMatches && unlistedMatches[1] && unlistedMatches[2]) {
    return {
      id: unlistedMatches[1],
      hash: unlistedMatches[2],
    }
  }

  throw new Error('Unknown Vimeo URL format: ' + url)
}
